import { Stack, Typography } from '@mui/material';

import { FormAwareCheckbox } from '@/components/form/formAwareInputs/FormAwareCheckbox';
import { MenuItem } from '@/components/poppers/MenuPopper/MenuItem';
import { useFormContext } from '@/components/react-hook-form';
import { ContextualHelpTooltip } from '@/modules/content/components/ContextualHelpTooltip';
import { useDispositiveProvisionsContext } from '@/modules/dispositiveProvisions/contexts/dispositiveProvisions.context';
import {
  DispositiveProvisionsFormV2Shape,
  PrimaryClientDeathEvent,
} from '@/modules/dispositiveProvisions/DispositiveProvisionsFormV2/DispositiveProvisionsFormV2.types';
import { useResiduaryPaysAllTaxes } from '@/modules/dispositiveProvisions/DispositiveProvisionsFormV2/hooks/formHooks';
import { isNonTaxableSource } from '@/modules/dispositiveProvisions/utils/taxUtils';
import { COLORS } from '@/styles/tokens/colors';

import { ResiduaryContextualHelp } from './ResiduaryContextualHelp';

interface ToggleResiduaryPaysTaxesMenuItemProps {
  deathEvent: PrimaryClientDeathEvent;
}

export function ToggleResiduaryPaysTaxesMenuItem({
  deathEvent,
}: ToggleResiduaryPaysTaxesMenuItemProps) {
  const { control } = useFormContext<DispositiveProvisionsFormV2Shape>();
  const dispositiveProvisionsContext = useDispositiveProvisionsContext();

  const { residuaryPaysAllTaxesFieldName } = useResiduaryPaysAllTaxes({
    deathEvent,
  });

  if (isNonTaxableSource(dispositiveProvisionsContext)) {
    return null;
  }

  return (
    <MenuItem
      key="residuary-taxes-toggle"
      label={
        <Stack direction="row" alignItems="center" spacing={1}>
          <FormAwareCheckbox<DispositiveProvisionsFormV2Shape>
            fieldName={residuaryPaysAllTaxesFieldName}
            control={control}
            label=""
          />
          <Typography variant="body-xs" color={COLORS.TEXT.PRIMARY}>
            All taxes paid out of residuary
          </Typography>
          <ContextualHelpTooltip>
            <ResiduaryContextualHelp />
          </ContextualHelpTooltip>
        </Stack>
      }
      onClick={(e) => {
        e.stopPropagation();
      }}
    />
  );
}
